export const darkTheme = {
  dark: true,
  colors: {
    background: "#0b0b12",
    surface: "#141426",
    primary: "#7c4dff",
    secondary: "#3c2a82",
    accent: "#c55cff",
    info: "#6aa6ff",
    success: "#3bd4a2",
    warning: "#f5b44f",
    error: "#ff6b6b",
  },
};

export const lightTheme = {
  dark: false,
  colors: {
    background: "#f7f6fb",
    surface: "#ffffff",
    primary: "#6a5cff",
    secondary: "#c8b8ff",
    accent: "#8c6bff",
    info: "#3b82f6",
    success: "#22c55e",
    warning: "#f59e0b",
    error: "#ef4444",
  },
};
